import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
      <h1 className="font-head font-semibold uppercase text-3xl text-[#1E1E1E]">No worries</h1>
      <p className="mt-3 text-[#6E6E6E]">Checkout was cancelled — nothing was charged. The shelf will be here when you're ready.</p>
      <Link to="/products" className="mt-6 inline-block bg-[#2D2D2D] text-[#F3F1EC] font-head uppercase tracking-wide text-sm px-6 py-3 hover:bg-[#242424] transition-colors">Back to products</Link>
    </div>
  );
}
